var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTravellersMini = function SvgTravellersMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 7A3.5 3.5 0 0 1 8 10.5V14H1v-3.5A3.5 3.5 0 0 1 4.5 7m6 2a2.5 2.5 0 0 1 2.5 2.5V14H9.5v-3.494c0-.423-.017-.833-.116-1.224.344-.18.7-.282 1.116-.282m.024-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4M4.5 1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
  })));
};
export default SvgTravellersMini;